import React from 'react';
import { MdInfoOutline } from 'react-icons/md';
import {
  Box, Flex,
  Grid,
  GridItem,
  HStack,
  Icon,
  List,
  ListItem,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Portal, Tag,
  Text
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { useCompanyCodes } from '../../../../../../../../../../../../services/company-service';
import ItemCodesBulkUpdatePopover from '../ItemCodesBulkUpdatePopover';

const ItemCodesHeaderTooltip = ({ companyId, insuredId, displayBulkUpdateTool = false }) => {
  const { data: companyCodes } = useCompanyCodes(companyId);

  return (
    <HStack>
      <Popover placement="bottom" trigger="hover">
        <PopoverTrigger>
          <Box><Icon as={MdInfoOutline} /></Box>
        </PopoverTrigger>
        <Portal>
          <PopoverContent _focus={{ boxShadow: 'none' }} p={2}>
            <PopoverArrow bg="white" pr={0} />
            <PopoverCloseButton color="white" m={0} p={0} />
            <PopoverBody padding="5 10">
              <Grid gap={3} templateColumns="repeat(5, 1fr)">
                <GridItem colSpan={3}>
                  <Text textStyle="bodyLg600">Code Descriptions</Text>
                  <List
                    borderRightColor="greyScale.200"
                    borderRightStyle="solid"
                    borderRightWidth={1}
                    color="greyScale.900"
                    marginTop="1.5rem"
                    p={0}
                  >
                    {companyCodes.map(
                      item => (
                        <ListItem key={`${item.id}`}>
                          <Flex>
                            <Tag bg="transparent" fontWeight="bold">
                              {item.letter}
                              :
                            </Tag>
                            {' '}
                            <Tag bg="transparent" color="greyScale.600">{item.description}</Tag>
                          </Flex>
                        </ListItem>
                      )
                    )}
                  </List>
                </GridItem>
                <GridItem colSpan={2} colStart={4}>
                  <Text marginLeft="7px" textStyle="bodyLg600">Code States</Text>
                  <List color="greyScale.600" marginTop="1.5rem" p={0}>
                    <ListItem paddingBottom={2}>
                      <Tag bgColor="transparent" color="primaryScale.900" textStyle="bodyXl600">&nbsp;A</Tag>
                      Audited Code Application
                    </ListItem>
                    <ListItem paddingBottom={2}>
                      <Tag bgColor="transparent" color="greyScale.900" textStyle="bodyXl">+A</Tag>
                      Suggested Code Application
                    </ListItem>
                    <ListItem paddingBottom={2}>
                      <Tag bgColor="transparent" color="greyScale.900" textStyle="bodyXl">-A</Tag>
                      Suggested Code Clearance
                    </ListItem>
                    <ListItem paddingBottom={2}>
                      <Tag
                        bgColor="transparent"
                        color="greyScale.900"
                        fontStyle="italic"
                        textStyle="bodyXl"
                      >
                        &nbsp;A
                      </Tag>
                      Waived Applied Code
                    </ListItem>
                    <ListItem paddingBottom={2}>
                      <Tag bgColor="transparent" color="greyScale.900" textStyle="bodyXl500">A*</Tag>
                      Applied Code w/ Exception
                    </ListItem>
                  </List>
                </GridItem>
              </Grid>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
      <Box>Code</Box>
      {displayBulkUpdateTool && (<ItemCodesBulkUpdatePopover companyId={companyId} insuredId={insuredId} />)}
    </HStack>
  );
};

ItemCodesHeaderTooltip.propTypes = {
  companyId: PropTypes.number.isRequired,
  displayBulkUpdateTool: PropTypes.bool
};

export default ItemCodesHeaderTooltip;
